import { ReactComponent as IconAlerts } from "assets/svg/menu-alerts.svg"
import { ReactComponent as IconCustomers } from "assets/svg/menu-customers.svg"
import { ReactComponent as IconDashboard } from "assets/svg/menu-dashboard.svg"
import { ReactComponent as IconDevice } from "assets/svg/menu-device.svg"
import { ReactComponent as IconUsers } from "assets/svg/menu-icon-users.svg"
import { ReactComponent as IconOrders } from "assets/svg/menu-orders.svg"
import { ReactComponent as IconWerehouse } from "assets/svg/menu-werehouse.svg"

import { useNewOrdersQuantity } from "hooks/useNewOrdersQuantity"

import { MenuBadge, MenuItem, MenuItemGroup, MenuSubItem } from ".."

export const VendorMenu = () => {
  const { data } = useNewOrdersQuantity()

  return (
    <>
      <MenuItem to="/dashboard" icon={<IconDashboard />} label="Dashboard" />

      <MenuItem to="/contractors" icon={<IconCustomers />} label="Contractors" />

      <MenuItem to="/admin/users" icon={<IconUsers />} label="Users List" />

      <MenuItem to="/orders" icon={<IconOrders />} label="Orders" badge={<MenuBadge count={data?.data?.quantity} />} />

      <MenuItemGroup icon={<IconDevice />} label="Devices" basePaths={["/devices"]} iconType="stroke">
        <MenuSubItem to="/devices" label="Thermostats" />
        <MenuSubItem to="/devices/sensors" label="Sensors" />
      </MenuItemGroup>

      <MenuItem to="/warehouse-list" icon={<IconWerehouse />} label="Warehouse" />

      <MenuItem to="/alerts" icon={<IconAlerts />} label="Alerts" />
    </>
  )
}
